import { FormikHelpers } from 'formik';

export function beforeMutation<Fields>(formikBag: FormikHelpers<Fields>, callback: Promise<void>) {
  formikBag.setStatus({});
  return callback;
}
